import {Devices} from "../../../widgets/devices";

export const DevicesPage = () => {
    return <Devices />
}